import React, { useState } from 'react';
import { ChevronRight, LogIn, UserPlus, CheckSquare, Square } from 'lucide-react';

const BRAND_COLORS = {
  primary: '#1a1a1a',
  secondary: '#7C3AED',
  accent: '#C9A961',
  light: '#F5F5F0',
  lightGray: '#E8E8E3',
};

const AuthSelection = ({ onSelectSignIn, onSelectSignUp }) => {
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  return (
    <div className="bg-white border-2 p-10" style={{ borderColor: BRAND_COLORS.primary }}>
      <div className="mb-10">
        <p className="text-xs font-light tracking-widest mb-4" style={{ color: BRAND_COLORS.accent }}>
          AUTHENTICATION
        </p>
        <h3 className="text-3xl font-light tracking-wide mb-4" style={{ color: BRAND_COLORS.primary }}>
          Welcome to SkillVend
        </h3>
        <p className="text-gray-600 font-light leading-relaxed mb-6">
          Choose how you'd like to continue
        </p>

        {/* T&C Checkbox */}
        <div
          className="flex items-start space-x-3 cursor-pointer group"
          onClick={() => setIsTermsAccepted(!isTermsAccepted)}
        >
          <div className="pt-0.5">
            {isTermsAccepted ? (
              <CheckSquare className="w-5 h-5" style={{ color: BRAND_COLORS.primary }} />
            ) : (
              <Square className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors" />
            )}
          </div>
          <p className="text-sm font-light text-gray-500 leading-tight">
            I agree to the <a href="/legal#terms" target="_blank" rel="noopener noreferrer" className="font-normal underline decoration-gray-300 underline-offset-2 hover:text-black transition-colors" onClick={(e) => e.stopPropagation()}>Terms of Service</a> and <a href="/legal#privacy" target="_blank" rel="noopener noreferrer" className="font-normal underline decoration-gray-300 underline-offset-2 hover:text-black transition-colors" onClick={(e) => e.stopPropagation()}>Privacy Policy</a>
          </p>
        </div>
      </div>

      <div className="space-y-4">
        {/* Sign In Option */}
        <button
          onClick={onSelectSignIn}
          disabled={!isTermsAccepted}
          className={`w-full p-6 border-2 font-light transition-all duration-300 group text-left
            ${isTermsAccepted
              ? 'bg-transparent hover:border-black hover:bg-gray-50 cursor-pointer'
              : 'bg-gray-50 opacity-50 cursor-not-allowed'
            }`}
          style={{ borderColor: isTermsAccepted ? BRAND_COLORS.lightGray : '#eee' }}
        >
          <div className="flex items-start justify-between">
            <div className="flex items-start space-x-4">
              <div
                className={`w-12 h-12 border-2 flex items-center justify-center transition-all duration-300
                  ${isTermsAccepted ? 'group-hover:border-black' : ''}`}
                style={{ borderColor: isTermsAccepted ? BRAND_COLORS.secondary : '#ddd' }}
              >
                <LogIn className="w-6 h-6" style={{ color: isTermsAccepted ? BRAND_COLORS.secondary : '#aaa' }} />
              </div>
              <div>
                <h4 className="text-lg font-light mb-2 tracking-wide" style={{ color: isTermsAccepted ? BRAND_COLORS.primary : '#aaa' }}>
                  Sign In
                </h4>
                <p className="text-sm font-light text-gray-600 leading-relaxed">
                  Already have an account? Sign in to continue
                </p>
              </div>
            </div>
            <ChevronRight className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 
              ${isTermsAccepted ? 'group-hover:translate-x-2' : ''}`}
            />
          </div>
        </button>

        {/* Sign Up Option */}
        <button
          onClick={onSelectSignUp}
          disabled={!isTermsAccepted}
          className={`w-full p-6 border-2 font-light transition-all duration-300 group text-left
            ${isTermsAccepted
              ? 'bg-transparent hover:border-black hover:bg-gray-50 cursor-pointer'
              : 'bg-gray-50 opacity-50 cursor-not-allowed'
            }`}
          style={{ borderColor: isTermsAccepted ? BRAND_COLORS.lightGray : '#eee' }}
        >
          <div className="flex items-start justify-between">
            <div className="flex items-start space-x-4">
              <div
                className={`w-12 h-12 border-2 flex items-center justify-center transition-all duration-300
                  ${isTermsAccepted ? 'group-hover:border-black' : ''}`}
                style={{ borderColor: isTermsAccepted ? BRAND_COLORS.accent : '#ddd' }}
              >
                <UserPlus className="w-6 h-6" style={{ color: isTermsAccepted ? BRAND_COLORS.accent : '#aaa' }} />
              </div>
              <div>
                <h4 className="text-lg font-light mb-2 tracking-wide" style={{ color: isTermsAccepted ? BRAND_COLORS.primary : '#aaa' }}>
                  Sign Up
                </h4>
                <p className="text-sm font-light text-gray-600 leading-relaxed">
                  New to SkillVend? Create your account
                </p>
              </div>
            </div>
            <ChevronRight className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 
              ${isTermsAccepted ? 'group-hover:translate-x-2' : ''}`}
            />
          </div>
        </button>
      </div>
    </div>
  );
};

export default AuthSelection;
